<template>
  <Modal v-model="suppliePlatformConfigModal" :title="$t('key1001853')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="suppliePlatformConfigChange">
    <div class="flex flex-wrap mb20">
      <div class="width_80">{{ $t('key1002187') }}</div>
      <CheckboxGroup class="flex flex-wrap flex_1" v-model="platformValueList">
        <Checkbox class="mr30 mb15" v-for="item in suppliePlatformList" :label="item.value">{{ item.name }}</Checkbox>
      </CheckboxGroup>
    </div>
    <template #footer>
      <Button @click="suppliePlatformConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="suppliePlatformConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {commonLocalStorage, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'suppliePlatformConfigModal',
  mixins: [Mixin],
  props: {
    enumData: {
      type: Object,
      default: null
    }
  },
  data() {
    let v = this;
    return {
      suppliePlatformConfigModal: false,
      suppliePlatformList: [],
      platformValueList: [],
      configParamKey: null,
      enumKey: 'SupplierPlatformEnum',
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initSuppliePlatformConfigData(paramKey, paramValue) {
      const configItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      let suppliePlatformSetSaas = configItems?.suppliePlatformSetSaas || [];
      this.suppliePlatformList = suppliePlatformSetSaas.map((val) => {
        return {
          value: val,
          name: this.enumData[`${this.enumKey}_${val}`] || '',
        }
      });
      this.platformValueList = paramValue || [];
      this.configParamKey = paramKey;
      this.suppliePlatformConfigModal = true;
    },
    // 确定
    suppliePlatformConfigBtn() {
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: JSON.stringify(this.platformValueList),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.suppliePlatformConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 监听弹窗
    suppliePlatformConfigChange(value) {
      if (!value) {
        this.platformValueList = [];
        this.configParamKey = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
